








































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import Campaign from '@/store/entities/campaign';
import dayjs from "dayjs";

@Component
export default class EditCampaign extends AbpBase {
  @Prop({type: Boolean, default: false}) value: boolean;
  campaign: Campaign = new Campaign();
  get loading() {
    return this.$store.state.campaign.loading;
  }
  get permissions() {
    return this.$store.state.campaign.permissions
  }

  dateChange(date, t) {
    let time = !date ? null : dayjs(date).format('YYYY-MM-DD HH:mm:ss');
    if (t === 1) {
      this.campaign.startTime = time;
    } else if (t === 2) {
      this.campaign.endTime = time;
    }
  }

  save() {
    (this.$refs.campaignForm as any).validate(async (valid: boolean) => {
      if (valid) {
        if (!this.campaign.startTime || !this.campaign.endTime) {
          this.$Message.error('请选择活动时间');
          return;
        }
   
        await this.$store.dispatch({
          type: 'campaign/update',
          data: this.campaign
        });
        (this.$refs.campaignForm as any).resetFields();
        this.$emit('save-success');
        this.$emit('input', false);
      }
    })
  }

  cancel() {
    (this.$refs.campaignForm as any).resetFields();
    this.$emit('input', false);
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit('input', value);
    } else {
      this.campaign = Util.extend(true, {}, this.$store.state.campaign.editCampaign);
    }
  }

  campaignRule = {
    name: [{required: true, message: this.L('FieldIsRequired', undefined, this.L('CampaignName')), trigger: 'blur'}],
    campaignCode: [{
      required: true,
      message: this.L('FieldIsRequired', undefined, this.L('campaignCode')),
      trigger: 'blur'
    }]
  }
}
